if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"12980": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"2870": 1,
"84855": 1,
"98264": 1,
"63117": 1,
"53401": 1,
"91597": 1,
"46257": 1,
"94807": 1,
"39231": 1,
"57685": 1,
"73908": 1,
"91127": 1,
"19513": 1,
"30553": 1,
"80716": 1,
"8054": 1,
"77306": 1,
"8225": 1,
"25091": 1,
"87330": 1,
"69647": 1,
"3696": 1,
"46248": 1,
"79552": 1,
"69262": 1,
"77200": 1,
"23624": 1,
"37642": 1,
"12334": 1,
"41330": 1,
"90345": 1,
"62535": 1,
"51804": 1,
"29603": 1,
"37978": 1,
"73635": 1,
"5391": 1,
"60150": 1,
"50527": 1,
"81805": 1,
"42050": 1,
"61814": 1,
"37806": 1,
"37123": 1,
"49326": 1,
"56234": 1,
"85120": 1,
"24643": 1,
"49743": 1,
"98715": 1,
"75634": 1,
"2303": 1,
"59008": 1,
"49384": 1,
"9148": 1,
"40952": 1,
"78709": 1,
"20207": 1,
"29585": 1,
"58694": 1,
"59372": 1,
"14218": 1,
"51527": 1,
"35124": 1,
"23977": 1,
"68481": 1,
"92965": 1,
"63124": 1,
"44660": 1,
"85137": 1,
"66702": 1,
"86640": 1,
"60221": 1,
"80100": 1,
"47492": 1,
"79867": 1,
"36338": 1,
"32098": 1,
"54621": 1,
"8993": 1,
"38287": 1,
"79303": 1,
"56297": 1,
"64448": 1,
"78554": 1,
"70742": 1,
"60469": 1,
"58946": 1,
"10269": 1,
"53819": 1,
"23452": 1,
"70023": 1,
"5211": 1,
"54498": 1,
"72441": 1,
"27825": 1,
"7694": 1,
"52669": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
